<div class="header-card">
	<div>
		<span class="title">{{"utilization_metrics_print.report_title" | translate}}</span>
		<div class="labels">
			<div class="label-content"><span>{{"shipments_history.site" | translate}}: </span><p *ngIf="siteInfo.name">{{ siteInfo.name }}</p> <p *ngIf="siteInfo.address">{{ siteInfo.address }}</p></div>
			<div class="label-content"><span>{{"warnings.period" | translate}}: </span><p>{{ selectedPeriod }}</p></div>
		</div>
	</div>

	<div class="battery-count">
		<span class="icon">🔋</span>
		<span class="count">{{ totalDevices }}</span>
		<div class="total">Total Batteries</div>
	</div>
</div>
